import {
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Grid,
  MenuItem,
} from '@mui/material'
import React from 'react'

const FluoresceinUptake = ({ moduleValues, setModuleValues, side }) => (
  <Grid item xs={12}>
    <FormControl fullWidth>
      <InputLabel>Fluorescein Uptake</InputLabel>
      <Select
        value={moduleValues?.[`Fluorescein Uptake (${side})`] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            [`Fluorescein Uptake (${side})`]: e.target.value,
          }))
        }
        label="Fluorescein Uptake"
      >
        {[
          'Not Used',
          'Normal',
          'Linear Uptake',
          'Dendritic Uptake',
          'Foreign Body Pooling',
          'Diffuse Staining',
        ].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default FluoresceinUptake
